import {Pipe, PipeTransform} from '@angular/core';
import {AppConfigService} from "../services/app-config.service";

@Pipe({
  name: 'wpMediaUrlFix',
})
export class WpMediaUrlFixPipe implements PipeTransform {
  constructor(private appConfigService: AppConfigService) {
  }

  transform(htmlContent: string): string {
    if (htmlContent != null) {
      const regex: RegExp = new RegExp(
        `(http|https):\/\/([^\/'"]*)\/cms-data\/`,
        'g'
      );
      const regexWebP =
        /(wp-content\/uploads\/[0-9]{4}\/[0-9]{2}\/)([-A-Z0-9+&@#\/%=~_|.-]+)(\.(jpg|jpeg|png))/gim;
      const regexWebP2 = /\.webp\.webp/gim;
      const regexRelativeUrl = /\/cms-data\/\/cms-data/gim;
      htmlContent = htmlContent
        .replace(regex, this.appConfigService.appConfig.wpBackend)
        .replace(regexWebP, '$1$2$3.webp')
        .replace(regexWebP2, '.webp')
        .replace(regexRelativeUrl, '/cms-data');
    }
    return htmlContent;
  }
}
